import { useEffect, useRef } from 'react';

const useVisibilityTracking = <T extends HTMLElement = HTMLElement>(callbackFunction: () => void, threshold: number = 1.0) => {
    const elementRef = useRef<T>(null);

    useEffect(() => {
        const element = elementRef.current;
        if (!element) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    callbackFunction();
                }
            },
            { threshold }
        );

        observer.observe(element);
        return () => observer.disconnect();
    }, [callbackFunction, threshold]);

    return elementRef;
};

export default useVisibilityTracking;
